import { createFileRoute } from "@tanstack/react-router";
import { RelatorioFunrural } from "pages/relatorios/pages/funrural";

export const Route = createFileRoute("/a/relatorios/funrural")({
	component: RelatorioFunrural,
});
